import { applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import createLogger from 'redux-logger';
import reduxReset from 'redux-reset';
// import throttle from 'lodash/throttle';
import { routerMiddleware } from 'connected-react-router';
import { createBrowserHistory } from 'history';

import StoreManager from './store_manager';

// import { loadState, saveState } from "./helper/local_storage_helper";
import rootReducer from "./reducer";
import config from "./config";

const history = createBrowserHistory();
const enhancers = [];
// const loadStateFromLocalStorage = loadState('app_state');
// const activeSession = sessionStorage.activeSession;
// const persistedState = (loadStateFromLocalStorage && activeSession) ? loadStateFromLocalStorage : config();
// const initialState = config();

const middleware = [thunk, routerMiddleware(history)];

if (process.env.NODE_ENV === "development") {
    // const devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : f => f;
    middleware.push(createLogger);
    // if (typeof devToolsExtension === "function") {
    //   enhancers.push(devToolsExtension);
    // }
}

const reduxComposer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const composeEnhancers = reduxComposer(
    applyMiddleware(...middleware),
    reduxReset(),
    ...enhancers
);

StoreManager.registerReducers(rootReducer(history));

const store = StoreManager.createStore(config(), composeEnhancers);

// store.subscribe(throttle(() => {
//     saveState({
//       ...store.getState()
//     }, 'app_state');
// }, 1000));

export { history, store };
